<header class="header text-white">
    <a class="navbar-brand" [routerLink]="['/']">
        <img src="Inmuebles/assets/img/logo_banorte.svg" alt="Banorte Logo" class="img-fluid">
    </a>
    <nav class="navbar navbar-expand-lg navbar-dark">
        <button class="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#navbarNav"
            aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="offcanvas offcanvas-end" tabindex="-1" id="navbarNav">
            <ul class="navbar-nav offcanvas-body">
                <li class="nav-item quienes-somos">
                    <a data-bs-dismiss="offcanvas" href="#" class="nav-link" [routerLink]="['/path', appConfig.getConfig('header.quienes_somos')]" (click)="onNavClick($event); dropdownOpen = false">¿Quiénes somos?</a>
                </li>
                <li class="nav-item conoce-mas dropdown" [class.show]="dropdownOpen">
                    <a class="nav-link" href="#" (click)="toggleDropdown($event); onNavClick($event)">
                        Conoce más
                        &nbsp;
                        <img src="Inmuebles/assets/iconos/icon_toolbar.svg" class="arrow" [class.open]="dropdownOpen">
                    </a>
                    <div class="dropdown-menu" [class.show]="dropdownOpen">
                        <a data-bs-dismiss="offcanvas" class="dropdown-item" href="#" [routerLink]="['/path', appConfig.getConfig('header.mas.proceso')]" (click)="dropdownOpen = false">Proceso de venta</a>
                        <a data-bs-dismiss="offcanvas" class="dropdown-item" href="#" [routerLink]="['/path', appConfig.getConfig('header.consejos.faq')]" (click)="dropdownOpen = false">Preguntas frecuentes</a>
                        <a data-bs-dismiss="offcanvas" class="dropdown-item" href="#" [routerLink]="['/path', appConfig.getConfig('header.consejos.interes')]" (click)="dropdownOpen = false">Sitios de interés</a>
                    </div>
                </li>
                <li class="nav-item directorio">
                    <a data-bs-dismiss="offcanvas" href="#" class="nav-link" [routerLink]="['/contacto']" (click)="onNavClick($event); dropdownOpen = false">Directorio</a>
                </li>
            </ul>
        </div>
    </nav>
</header>
<div class="subheader">
    <p class="inmuebles-title">INMUEBLES</p>
</div>
<nav aria-label="breadcrumb" class="breadcrumb-container">
    <div class="align-items-center w-100">
        <a href="#" [routerLink]="['/home']" class="breadcrumb-link">Inicio</a>

        <ng-container *ngFor="let item of breadcrumb; let i = index">
            <img [src]="breadcrumb.length === 2 && i === 0 ? 'Inmuebles/assets/iconos/bread_der_2.svg' : 'Inmuebles/assets/iconos/bread_der_1.svg'" class="breadcrumb-icon">
            <span [ngClass]="{'breadcrumb-item': true, 'breadcrumb-last': i === breadcrumb.length - 1}">{{ item }}</span>
        </ng-container>
    </div>
</nav>